<template>
  <p v-if="smartText" v-html="smartText" />
  <p v-else-if="isEditModeActive" class="placeholder-description">
    Some Description text (Optional)
  </p>
</template>

<script setup>
import { computed } from "vue";
import { transformTextToLinks } from "@/helpers/utils.js";

const props = defineProps({
  text: { type: String, default: "" },
  editing: { type: Boolean, default: false },
  active: { type: Boolean, default: false },
  item: { type: Object, default: () => ({}) },
});

const smartText = computed(() => {
  return transformTextToLinks(props.text);
});

const isEditModeActive = computed(
  () => props.editing && props.active && !props.item.componentFromRepeatField,
);
</script>
